import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

import { ApiService } from '../../shared/api.service';
import {OtpComponent } from './otp.component';
import { NbDialogService } from '@nebular/theme';


@Component({
    selector: 'nb-dialog',
    template: `
    <html>
		<head>
			<script>(function(){var colombiaPixelURL = 'https://ade.clmbtech.com/cde/eventTracking.htm?pixelId=6157&_w=1&rd='+new Date().getTime();(new Image()).src = colombiaPixelURL;})();</script><noscript><img height='1' width='1' style='display:none' src='https://ade.clmbtech.com/cde/eventTracking.htm?pixelId=6157&_w=1'/></noscript>
		</head>
    <nb-card class="registered-card">
   
      <nb-card-body>
     
                   You Have been Successfully Registered. Please login with OTP
           
      </nb-card-body>
      <nb-card-footer>
        <button nbButton hero status="primary" (click)="Ok()">OK</button> 
        
      </nb-card-footer>
    </nb-card>
    <html>
    `,
    styles: [`
        .registered-card { margin: 0; width: 100%; max-width: 100%; min-height: 150px; }
        .registered-card nb-card-body { overflow-wrap: anywhere; }
        @media (max-width: 575.98px) {
            .registered-card { min-height: 0; }
            .registered-card nb-card-body, .registered-card nb-card-footer { padding: 0.75rem 1rem; font-size: 15px; }
            .registered-card button { width: 100%; }
        }
    `],
    })
    export class RegisteredComponent {
        @Input() email:string;
        @Input()  password:string;
        @Input()    userCountryCode :string;
        @Input()    userContactNo :string;
        @Input()    user_id :string;
        otp;
        alertflag=0;
            constructor(protected ref: NbDialogRef<RegisteredComponent>,
                protected api : ApiService,
                private dialogService: NbDialogService,) {
            }

            ngOnInit() {
                var file_name = 'BSc in AQF.pdf';
                var file_name1 = 'MSc in AQF.pdf';
                // this.api.downloadPDF(file_name)
                // .subscribe(data => {
                //     saveAs(data, file_name);
                // });
            }
        
            Ok(){
                this.dialogService.open(OtpComponent, {
                    closeOnBackdropClick : false,
                    context: {
                     email: this.email,
                     password:this.password,
                     userCountryCode:this.userCountryCode,
                     userContactNo :this.userContactNo,
                     user_id  : this.user_id
                    },
                 });
                 this.ref.close();                
            }
        
            close()
            {
                this.alertflag=0;         
            }
            dismiss() {            
                this.ref.close();
                }
            
        }